import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function PageBreadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-xs text-foreground-500 md:text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          {item.to ? (
            <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-foreground-900">
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}